/** 消息通知抽屉（→ demo #sub-notice 右侧滑入） */
export const useNoticeNav = () => {
  const open = useState('notice-drawer-open', () => false)

  const openNotice = () => {
    open.value = true
  }

  const closeNotice = () => {
    open.value = false
  }

  return { open, openNotice, closeNotice }
}
